import { DataSyncOkResponseSchema } from '../../shared/data-sync';
export const readPersonioForSetupContract = {
    method: 'POST',
    path: '/api/v2/data-sync/personio/setup-read',
    description: 'Read the linked Personio and store the snapshot the initial-setup rows seed from',
    responseSchema: DataSyncOkResponseSchema,
    statusCodes: {
        success: 200,
        errors: {
            400: 'Bad Request - initial setup is already completed, or Personio rejected the credentials',
            401: 'Unauthorized - user not authenticated',
            403: 'Forbidden - not allowed to manage the data source',
            409: 'Conflict - Personio is not linked, its stored credentials can no longer be read, or the Personio read was incomplete or failed'
        }
    }
};

//# sourceMappingURL=read-personio-for-setup.contract.js.map